import { render, staticRenderFns } from "./BannerClientDetailStore.vue?vue&type=template&id=2dd248b8&scoped=true"
import script from "./BannerClientDetailStore.vue?vue&type=script&lang=js"
export * from "./BannerClientDetailStore.vue?vue&type=script&lang=js"
import style0 from "./BannerClientDetailStore.vue?vue&type=style&index=0&id=2dd248b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd248b8",
  null
  
)

export default component.exports